import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    loadingUser: false,
    scalifyAccessToken: null,
    toasts:[],
    currentConnectedUsers:0,
    lastConnectedUsers:0,
    listAccounts:[],
    loadingAccounts:true
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
